import { Icon, IconName } from "@zapier/zinnia-icons";
import {
  Button,
  ButtonProps,
  Link,
  LinkProps,
  Spacer,
  Text,
} from "@zapier/design-system";

import style from "./EmptyTableDisplay.module.css";

type ButtonVariant = ButtonProps["variant"];
type LinkVariant = LinkProps["variant"];

interface EmptyTableDisplayProps {
  actionButtonHref?: string;
  headerText: string;
  icon: IconName;
  onActionButton?: () => void;
  actionButtonText?: string;
  actionButtonColor?: ButtonVariant | LinkVariant;
  actionButtonIcon?: IconName;
  onSecondActionButton?: () => void;
  secondActionButtonText?: string;
  subHeaderText: string | JSX.Element;
  secondActionButtonHref?: string;
  sectionActionButtonColor?: ButtonVariant | LinkVariant;
  secondActionButtonIcon?: IconName;
}

const EmptyTableDisplay = ({
  actionButtonHref,
  headerText,
  icon,
  onActionButton,
  actionButtonColor,
  actionButtonText,
  actionButtonIcon,
  onSecondActionButton,
  secondActionButtonText,
  subHeaderText,
  secondActionButtonHref,
  sectionActionButtonColor,
  secondActionButtonIcon,
}: EmptyTableDisplayProps) => {
  return (
    <div className={style.emptyTableDisplay}>
      <div className={style.textWrapper}>
        <Spacer height={80} />
        <Icon name={icon} size="36" color="GrayWarm6" />
        <Spacer height={10} />
        <Text tag="p" type="SectionHeader">
          {headerText}
        </Text>
        <Spacer height={10} />
        <Text tag="p" type="Body1Multiline" color="TextWeaker">
          {subHeaderText}
        </Text>
        {actionButtonText && (onActionButton || actionButtonHref) ? (
          <>
            <Spacer height={20} />
            <div className={style.buttonWrapper}>
              {actionButtonHref ? (
                <Link
                  href={actionButtonHref}
                  variant={(actionButtonColor || "secondary") as LinkVariant}
                  iconPosition={actionButtonIcon ? "start" : undefined}
                >
                  {actionButtonIcon && <Icon name={actionButtonIcon} />}
                  {actionButtonText}
                </Link>
              ) : (
                <Button
                  variant={(actionButtonColor || "secondary") as ButtonVariant}
                  onPress={onActionButton}
                  iconPosition={actionButtonIcon ? "start" : undefined}
                >
                  {actionButtonIcon && <Icon name={actionButtonIcon} />}
                  {actionButtonText}
                </Button>
              )}
              {secondActionButtonText &&
              (onSecondActionButton || secondActionButtonHref) ? (
                secondActionButtonHref ? (
                  <Link
                    href={secondActionButtonHref}
                    variant={
                      (sectionActionButtonColor || "secondary") as LinkVariant
                    }
                    iconPosition={secondActionButtonIcon ? "start" : undefined}
                  >
                    {secondActionButtonIcon && (
                      <Icon name={secondActionButtonIcon} />
                    )}
                    {secondActionButtonText}
                  </Link>
                ) : (
                  <Button
                    variant={
                      (sectionActionButtonColor || "secondary") as ButtonVariant
                    }
                    onPress={onSecondActionButton}
                    iconPosition={secondActionButtonIcon ? "start" : undefined}
                  >
                    {secondActionButtonIcon && (
                      <Icon name={secondActionButtonIcon} />
                    )}
                    {secondActionButtonText}
                  </Button>
                )
              ) : null}
            </div>
          </>
        ) : null}

        <Spacer height={80} />
      </div>
    </div>
  );
};
export default EmptyTableDisplay;
